class PaysForItself extends HTMLElement {
  constructor () {
    super()
    this.onLinkClick = this.onLinkClick.bind(this)
    this.onVariantChange = this.onVariantChange.bind(this)
  }

  connectedCallback () {
    this.trigger = this.querySelector('.pays-for-itself__trigger')
    this.messageEl = this.querySelector('.pays-for-itself__message')
    this.template = this.querySelector('.pays-for-itself__modal-template')

    if (this.trigger) {
      this.trigger.addEventListener('click', this.onLinkClick)
    }

    document.addEventListener('variantChange', this.onVariantChange)
  }

  disconnectedCallback () {
    if (this.trigger) {
      this.trigger.removeEventListener('click', this.onLinkClick)
    }
    document.removeEventListener('variantChange', this.onVariantChange)
  }

  get savingPerNight () {
    return Number(this.dataset.savingPerNight) || 0
  }

  get textTemplate () {
    return this.dataset.textTemplate || ''
  }

  get calcTemplate () {
    return this.dataset.calcTemplate || ''
  }

  get savingFormatted () {
    return this.dataset.savingFormatted || ''
  }

  get nightsLabel () {
    return this.dataset.nightsLabel || 'nights'
  }

  onLinkClick () {
    if (!this.template) return

    const modal = document.querySelector('reusable-modal')
    if (!modal) return

    const modalTitle = modal.querySelector('.reusable-modal__title')
    const modalBody = modal.querySelector('.reusable-modal__body')

    if (modalTitle) {
      modalTitle.textContent = this.dataset.modalTitle || ''
    }

    if (modalBody) {
      const content = this.template.content.cloneNode(true)
      modalBody.innerHTML = ''
      modalBody.appendChild(content)
    }

    window.dispatchEvent(new CustomEvent('open:modal', {
      detail: {
        width: '460px',
      },
    }))
  }

  onVariantChange (event) {
    const variant = event.detail?.variant
    if (!variant || !this.savingPerNight) return

    const priceWhole = Math.floor(variant.price / 100)
    const nights = Math.ceil(priceWhole / this.savingPerNight)

    if (nights <= 0) return

    this.dataset.variantPrice = variant.price

    if (this.messageEl && this.textTemplate) {
      this.messageEl.textContent = this.textTemplate.replace('[nights]', nights)
    }

    const calcEl = this.template?.content?.querySelector('[data-pfi-calculation]')
    if (calcEl && this.calcTemplate) {
      const productName = document.querySelector('.product-body h1')?.textContent?.trim() || ''
      const formattedPrice = this.formatMoney(variant.price)
      const nightsBold = `<strong class="pays-for-itself__calculation-nights">${nights} ${this.nightsLabel}</strong>`

      calcEl.innerHTML = this.calcTemplate
        .replace('[product]', productName)
        .replace('[price]', formattedPrice)
        .replace('[saving]', this.savingFormatted)
        .replace('[nights]', nightsBold)
    }
  }

  formatMoney (cents) {
    if (window.FinanceUtils?.formatMoneyFromCents) {
      return window.FinanceUtils.formatMoneyFromCents(cents)
    }
    return (cents / 100).toFixed(0)
  }
}

if (!customElements.get('pays-for-itself')) {
  customElements.define('pays-for-itself', PaysForItself)
}
